
import { Component, Vue } from 'vue-property-decorator';
import { SessionManager } from "@/components/utils/utils";

@Component
export default class LandingPage extends Vue {
    
    isLoggedIn= false
    pageReady = false
    safetyInst = false
      
    async mounted() {
        this.pageReady = false;
        this.safetyInst = false;
        await SessionManager.getUserInfo(this.$store);
        if(this.$store.state.Common.userId !== ""){
            this.isLoggedIn = true
            
        }else{
            this.isLoggedIn = false;
            this.pageReady = true;
        } 
    }
  
    public reTakeSurvey() {
        this.$router.push({ name: "pre-qualification" });
    }    
  
};
